/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { format } from 'date-fns'
import { IColumn } from 'types'
import MainTableActionButtons from 'components/organisms/MainTableActionButtons'
import { Button, Tooltip, Box, useTheme } from '@mui/material'


export const useTableModel = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();

  const handleStatusFormat = useCallback(
    (cellValue: string) => (cellValue ? t(`rti-intervention-status.${cellValue}`) : ''),
    [],
  )

  const handleDateFormat = useCallback(
    (cellValue: string) => (cellValue ? format(new Date(cellValue), 'dd-MM-yyyy') : ''),
    [],
  )

  const handleNameFormat = useCallback((cellValue: string, row: any) => {
    return <Box onClick={ () => navigate(`/rti-students/${row.student_id}#interventions`) } sx={{ cursor: 'pointer', '&:hover': {
      color: 'red'
    } }}>{cellValue}<br/>{row.student_academic_id && "#"+row.student_academic_id}</Box>
  }, [])


  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <MainTableActionButtons baseUrl={'/rti-interventions/'} row={row} />,
    [],
  )


  const columns: IColumn[] = [
    {
      title: `${t('common.groups')}`,
      field: 'student_groups',
      order: false,
      width: '10%',
    },
    {
      title: `${t('common.student')}`,
      field: 'student_name',
      width: '20%',
      order: true,
      format: handleNameFormat,
    },
    {
      title: `${t('common.type')}`,
      field: 'intervention_type',
      width: '30%',
      order: true,
    },
    {
      title: `${t('rti.tier')}`,
      field: 'tier',
      width: '10%',
      order: true,
    },
    {
      title: `${t('common.status')}`,
      field: 'status',
      width: '10%',
      order: true,
      format: handleStatusFormat,
    },
    {
      title: `${t('common.start-date')}`,
      field: 'start_date',
      order: true,
      width: '10%',
      format: handleDateFormat,
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}
